
import { mapGetters } from "vuex";

export default {
    components: {
        Topbar: () => import("~/components/global/Topbar"),
        Bottombar: () => import("~/components/global/Bottombar"),
        PageLoader: () => import("~/components/global/modal/PageLoader"),
        PreContentLoader: () =>
            import("~/components/global/modal/PreContentLoader"),
        ApiLoader: () => import("~/components/global/modal/ApiLoader"),
        Catcher: () => import("~/components/global/modal/Catcher"),
        ContentSpaceFiller: () =>
            import("~/components/global/ContentSpaceFiller"),
    },
    data: () => ({
        padding: 0,
    }),
    watch: {
        async $route(to, from) {
            this.$store.commit("global/catcher/hideHasError", {
                status: false,
            });
            await this.onResize();
        },
    },
    computed: {
        ...mapGetters({
            getShowStatus: "global/modal/getShowStatus",
            getHasError: "global/catcher/getHasError",
        }),
    },
    methods: {
        async initialize() {
            await this.onResize();
            // await this.googleAnalytics();
            // await this.jsonLd();
            // await this.chatbot();

            this.toggleModalStatus({ type: "announcements", status: true });
            document.addEventListener("contextmenu", (event) =>
                event.preventDefault()
            );
            window.addEventListener("load", this.onResize);
            window.addEventListener("resize", this.onResize);
        },

        async googleAnalytics() {
            try {
                const createScript = (src, innerText = null) => {
                    const scriptElement = document.createElement("script");
                    scriptElement.async = false;
                    scriptElement.defer = true;
                    if (src) {
                        scriptElement.src = src;
                    }
                    if (innerText) {
                        scriptElement.innerText = innerText;
                    }
                    return scriptElement;
                };

                const insertScript = (script) => {
                    const firstScript =
                        document.getElementsByTagName("script")[0];
                    firstScript.parentNode.insertBefore(script, firstScript);
                };

                const scripts = [
                    {
                        src: "https://www.googletagmanager.com/gtag/js?id=UA-39035388-11",
                    },
                    {
                        src: "https://www.googletagmanager.com/gtag/js?id=AW-10879139176",
                    },
                    {
                        type: "noscript",
                        content: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KF2LKJF" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
                    },
                    {
                        src: null,
                        innerText: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-KF2LKJF');`,
                    },
                    {
                        src: null,
                        innerText: `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'UA-39035388-11');`,
                    },
                    {
                        src: null,
                        innerText: `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'AW-10879139176');`,
                    },
                ];

                const nonce = Math.floor(Date.now() / 1000)
                    .toString()
                    .slice(0, 7);
                for (const { type, src, innerText } of scripts) {
                    const script =
                        type === "noscript"
                            ? document.createElement("noscript")
                            : createScript(src, innerText);
                    if (type === "noscript") {
                        script.innerHTML = src;
                    }
                    script.setAttribute("nonce", nonce);
                    script.type = "text/javascript";
                    await this.$nextTick();
                    insertScript(script);
                }
            } catch (error) {
                console.error("Error setting up Google Analytics:", error);
            }
        },

        async jsonLd() {
            try {
                const nonce = Math.floor(Date.now() / 1000)
                    .toString()
                    .slice(0, 7);

                const scriptElement = document.createElement("script");
                scriptElement.setAttribute("nonce", nonce);
                scriptElement.type = "application/ld+json";
                scriptElement.nonce = nonce;
                scriptElement.async = false;
                scriptElement.defer = true;
                scriptElement.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "InsuranceAgency",
                    name: "Malayan Insurance",
                    image: "https://malayan.com/_ipx/cbimage.png",
                    url: "https://malayan.com/",
                    telephone: "632 8628 8628",
                    address: {
                        "@type": "PostalAddress",
                        streetAddress:
                            "4F Yuchengco Tower I 484 Quintin Paredes St. Binondo",
                        addressLocality: "Manila",
                        postalCode: "1006",
                        addressCountry: "PH",
                    },
                    geo: {
                        "@type": "GeoCoordinates",
                        latitude: 14.5988884,
                        longitude: 120.975891,
                    },
                    openingHoursSpecification: {
                        "@type": "OpeningHoursSpecification",
                        dayOfWeek: [
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                            "Sunday",
                        ],
                        opens: "00:00",
                        closes: "23:59",
                    },
                    sameAs: [
                        "https://www.facebook.com/MalayanInsurancePH/",
                        "https://www.instagram.com/malayaninsuranceph/",
                        "https://www.linkedin.com/company/malayan-insurance-co-inc-/posts/?feedView=all",
                    ],
                });

                await this.$nextTick();
                document.head.appendChild(scriptElement);
            } catch (error) {
                console.error("Error setting up JSON-LD:", error);
            }
        },

        async chatbot() {
            try {
                const nonce = Math.floor(Date.now() / 1000)
                    .toString()
                    .slice(0, 7);
                const scriptElement = document.createElement("script");
                scriptElement.setAttribute("nonce", nonce);
                scriptElement.type = "text/javascript";
                scriptElement.nonce = nonce;
                scriptElement.async = false;
                scriptElement.defer = true;
                scriptElement.src = `${
                    document.location.protocol === "https:"
                        ? "https://"
                        : "http://"
                }cdn.chatbot.com/widget/plugin.js`;

                window.__be = window.__be || {};
                window.__be.id = "64fab714714b8900074d64a2";

                await this.$nextTick();
                document
                    .getElementsByTagName("script")[0]
                    .parentNode.insertBefore(scriptElement, null);
            } catch (error) {
                console.error("Error setting up chatbot:", error);
            }
        },

        async onResize() {
            const isMobile = document.documentElement?.clientWidth <= 768;
            this.$store.commit("global/settings/enteredMobile", {
                status: isMobile,
            });
            await this.autoPadding();
        },

        async autoPadding() {
            const targetHeight = document.querySelector(".__n");
            this.padding = targetHeight
                ? `${targetHeight.offsetHeight}px`
                : "0";
            await this.$nextTick();
        },
    },
    async mounted() {
        await this.initialize();
    },
    destroyed() {
        window.removeEventListener("load", this.onResize);
        window.removeEventListener("resize", this.onResize);
    },
};
